if (!customElements.get('mjhome-product-pairing')) {
  class MJHomeProductPairing extends HTMLElement {
    connectedCallback() {
      this.config = JSON.parse(this.querySelector('[data-pair-config]').textContent);
      this.formId = this.dataset.formId;
      this.check = this.querySelector('[data-addon-checked]');
      this.select = this.querySelector('[data-addon-variant]');
      this.qty = this.querySelector('[data-addon-quantity]');
      this.config.addonVariants = this.config.addonVariants.filter(v => v.available && (!v.tracked || v.stock > 0) && !/scratch|minor imperfection|dent/i.test(`${v.title} ${v.variantTitle || ''}`));
      const allowedIds = new Set(this.config.addonVariants.map(v => String(v.id)));
      this.select.querySelectorAll('option').forEach(option => { if (!allowedIds.has(option.value)) option.remove(); });
      if (!this.config.addonVariants.length) return;
      this.message = this.querySelector('[data-pair-message]');
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.addEventListener('change', () => { this.message.textContent = ''; this.sync(); }, { signal });
      document.addEventListener('input', () => this.sync(), { signal });
      document.addEventListener('variant:change', () => queueMicrotask(() => this.sync()), { signal });
      document.addEventListener('submit', event => this.submit(event), { capture: true, signal });
      this.sync();

    }
    disconnectedCallback() { this.abort?.abort(); }
    form() { return document.getElementById(this.formId); }
    money(cents) { return new Intl.NumberFormat(this.config.locale, { style: 'currency', currency: this.config.currency }).format(cents / 100); }
    selection() {
      const form = this.form();
      const data = form ? new FormData(form) : new FormData();
      const main = this.config.mainVariants.find(v => String(v.id) === String(data.get('id') || form?.querySelector('[name="id"]')?.value));
      const addon = this.config.addonVariants.find(v => String(v.id) === this.select.value);
      return { main, addon, data, mainQty: Math.max(1, parseInt(data.get('quantity'), 10) || 1), addonQty: Math.max(1, parseInt(this.qty.value, 10) || 1) };
    }
    sync() {
      const { main, addon, mainQty, addonQty } = this.selection();
      if (!main || !addon) return;
      const excludedMain = /scratch|minor imperfection|dent/i.test(main.title || '');
      this.hidden = excludedMain;
      if (excludedMain) this.check.checked = false;
      const available = addon.available && (!addon.tracked || addon.stock > 0);
      if (!available) this.check.checked = false;
      this.querySelector('[data-pair-details]').hidden = !this.check.checked;
      this.check.disabled = !available || this.busy === true;
      this.select.disabled = this.busy === true;
      this.qty.disabled = this.busy === true;
      this.qty.max = addon.tracked ? Math.min(20, addon.stock) : 20;
      this.querySelector('[data-addon-price]').textContent = this.money(addon.price);
      this.querySelectorAll('.mj-pair__image-link,.mj-pair__title').forEach(link => { if (addon.url) link.href = addon.url; });
      if (addon.title) this.querySelector('.mj-pair__title').textContent = addon.title;
      const image = this.querySelector('.mj-pair__image');
      if (image && addon.title) image.alt = addon.title;
      if (image && addon.image && image.getAttribute('src') !== addon.image) { image.src = addon.image; image.removeAttribute('srcset'); }
      this.querySelector('[data-pair-total]').textContent = this.config.text.total.replace('__TOTAL__', this.money(main.price * mainQty + (this.check.checked ? addon.price * addonQty : 0)));
    }
    async submit(event) {
      if (event.target.getAttribute('id') !== this.formId || !this.check.checked) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      if (this.busy) return;
      const { main, addon, data, mainQty, addonQty } = this.selection();
      if (!event.target.reportValidity() || !this.qty.reportValidity()) return;
      if (!main?.available || !addon?.available || (addon.tracked && addonQty > addon.stock)) { this.message.textContent = this.config.text.unavailable; return; }
      const properties = {};
      for (const [key, value] of data) {
        const match = key.match(/^properties\[(.+)\]$/);
        if (match && typeof value === 'string') properties[match[1]] = value;
      }
      const mainItem = { id: main.id, quantity: mainQty, properties };
      if (data.get('selling_plan')) mainItem.selling_plan = data.get('selling_plan');
      this.busy = true;
      event.target.setAttribute('aria-busy', 'true');
      this.message.textContent = this.config.text.adding;
      this.sync();
      try {
        const response = await fetch(this.config.cartAddUrl, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [mainItem, { id: addon.id, quantity: addonQty }] }) });
        const result = await response.json();
        if (!response.ok || result.status) throw new Error(result.description || result.message || '');
        window.location.assign(this.config.cartUrl);
      } catch (error) { this.message.textContent = `${this.config.text.error} ${error.message}`.trim(); }
      finally { this.busy = false; event.target.removeAttribute('aria-busy'); this.sync(); }
    }
  }
  customElements.define('mjhome-product-pairing', MJHomeProductPairing);
}
